import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';
import { useGrowthThreadEnabled } from '../../../GrowthHub/growthFlags';
import { registryKeys, useIntelClaimsForLinks } from '../../../Registries/hearsay/hooks';
import { PURSUIT_THREAD_KEY } from '../pursuitQueryKeys';
/**
 * GRW-20: the claim read targets for a pursuit: `RELEVANT_TO PURSUIT {id}`.
 * Claim links are immutable, so a merged stub's claims stay on the stub; REG
 * expands registry merge chains, and the stub ids are added once the header
 * returns them (TODO(GRW-18): `merged_from` refs are not on
 * GetPursuitHeader.related yet).
 */ export function pursuitHearsayLinks(captureProjectId) {
    return captureProjectId ? [
        {
            linkRole: 'RELEVANT_TO',
            targetKind: 'PURSUIT',
            targetId: captureProjectId
        }
    ] : [];
}
/**
 * The pursuit's hearsay as REG returns it for the signed-in viewer (the
 * `hearsay.read` ceiling AND each claim's audience; the author always sees
 * their own). GRW never filters or infers audience itself. Idle with
 * growth_thread_v1 off: nothing in GRW-20 renders then.
 */ export function usePursuitHearsay(captureProjectId) {
    const threadOn = useGrowthThreadEnabled();
    const links = useMemo(()=>pursuitHearsayLinks(captureProjectId), [
        captureProjectId
    ]);
    return useIntelClaimsForLinks(links, threadOn);
}
/** After a create or an audience change: refetch the thread and REG's claim lists. */ export function useInvalidateHearsay() {
    const qc = useQueryClient();
    return useCallback(()=>{
        void qc.invalidateQueries({
            queryKey: [
                PURSUIT_THREAD_KEY
            ]
        });
        void qc.invalidateQueries({
            queryKey: registryKeys.all
        });
    }, [
        qc
    ]);
}
